import { useBadgeCount } from './useBadgeCount';
import { useFaviconBadge } from './useFaviconBadge';

export function useNotificationFavicon() {
  const { data: badgeCount } = useBadgeCount({ grouped: true });
  useFaviconBadge((badgeCount ?? 0) > 0);
}
